import Immutable from 'immutable';
import { createSelector } from 'reselect';
import {
  currentUserIdSelector,
  currentCohortPathSelector,
} from '../Auth/selectors';
import { id } from '../../web/utilities/functions';

export const badgesSelector = (state) => state.IssuedBadges || Immutable.Map();

export const badgesById = createSelector(badgesSelector, (badges) =>
  badges.get('byId')
);

export const makeSelectUserCohortBadgesHasLoaded = (userId, cohortPath) =>
  createSelector(badgesSelector, (badges) => {
    return badges.hasIn(['byUserCohort', userId, cohortPath]);
  });

export const selectCurrentUserCohortBadges = createSelector(
  currentUserIdSelector,
  currentCohortPathSelector,
  badgesSelector,
  (userId, cohortPath, badges) => {
    const badgeIds = badges.getIn(
      ['byUserCohort', userId, cohortPath],
      Immutable.List()
    );
    return badgeIds
      .map((badgeId) => badges.getIn(['byId', badgeId]))
      .filter(id);
  }
);
